<template>
  <div class="w-90">
    <b-card bg-variant="light">
      <h1 id="jump-to-header">{{heading || generated_heading}}</h1>
      <b-row>
        <b-col md="4">
          <product-listing-show :id="id" @gotResponseData="assignAttrs"></product-listing-show>
        </b-col>
        <b-col md="8">
          <b-tabs
            active-nav-item-class="font-weight-bold text-uppercase text-warning"
            active-tab-class="font-weight-bold text-success"
            content-class="mt-3"
            lazy
          >
            <b-tab title="Assets" active>
              <product-item-index
                :filtering="filtering"
                :ams_template="ams_template"
              ></product-item-index>
            </b-tab>
            <b-tab title="Interest">
              <integer-reference-information-card-index
                :reference_type='reference_type'
                :filtering="filtering_reference"
                :reference_id="interest_id"
              ></integer-reference-information-card-index>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import ProductListingShow from './ProductListingShow.vue'
import ProductItemIndex from './ProductItemIndex.vue'
import IntegerReferenceInformationCardIndex from './IntegerReferenceInformationCardIndex.vue'

export default {
  components: {
    ProductListingShow,
    ProductItemIndex,
    IntegerReferenceInformationCardIndex
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  data () {
    return {
      generated_heading: undefined,
      reference_type: 'Interest',
      interest_id: undefined,
      filtering: {
        product_listing_ids: this.id
      },
      ams_template: {
        type: 'product-items',
        description: undefined,
        attributes: {
          'product-listing-id': this.id,
          'storage-space-id': undefined,
          'purchased-price-cents': 0,
          'estimated-min-price-cents': 0,
          'estimated-max-price-cents': 0,
          'authenticated-min-price-cents': 0,
          'authenticated-max-price-cents': 0,
          'asking-price-cents': 0,
          'estimated-quality': 9000,
          'authenticated-quality': 0
        }
      },
      filtering_reference: {
        reference_to_type: 'ProductListing',
        reference_to_id: this.id
      },
      ams_template_reference: {
        type: 'polymorphic-references',
        descrition: undefined,
        attributes: {
          'reference-to-type': "ProductListing",
          'reference-to-id': this.id
        }
      },
      attrs: {},
    }
  },
  methods: {
    assignAttrs(attrs, description) {
      this.generated_heading = description
      this.attrs = Object.assign( {}, attrs)
      this.ams_template.description = description + '# ' + attrs['edition']
      let interest = this.attrs.included.find(el => el.type === 'interests')
      this.interest_id = interest?.id
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>